import { createSelector } from 'reselect';
import CompliancePredesResdesOperatorMismatchColumns from '../../containers/CompliancePredesResdesOperatorMismatchColumns';
import ReportDefinitions from '../../../../../../common/config/ReportDefinitions';

export const getGeneratedOnDateTime =
  state => state.reporting.PREDES_RESDES_OPERATOR_MISMATCH.metadata.generatedOnDateTime;

export const getIsLoading =
  state => state.reporting.PREDES_RESDES_OPERATOR_MISMATCH.isLoading;

export const getData =
  ReportDefinitions.PREDES_RESDES_OPERATOR_MISMATCH.getDataFunction();

export const getColumns =
  createSelector(getData, CompliancePredesResdesOperatorMismatchColumns);
